import { useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import GulfStudents3 from "../../../Assets/Gulf_Students/Peer_Mentorship_Network.webp"
import GulfStudentsData from "../../../Data/Gulf_Students/GulfStudentsData"
import PeerMentorNetworkData from "../../../Data/Gulf_Students/Services_Data/PeerMentorNetworkData"
import PeerMentorshipNetworkData from "../../../Data/Gulf_Students/Testimonial_Data/PeerMentorshipNetworkData"
import "../../CSS/GulfStudentsCSS.css"
import "../../CSS/GulfStudentsForm.css"
import TestimonialCard from "../TestimonialCard"

const PeerMentorshipNetwork = () => {
    const navigate = useNavigate();
    const [stuName, setStuName] = useState();
    const [email, setEmail] = useState();
    const [departure, setDeparture] = useState();
    const [origin, setOrigin] = useState();
    const [destination, setDestination] = useState();
    const [university, setUniversity] = useState();
    const [major, setMajor] = useState();
    const handleSubmit = (e) => {
        if (!stuName || !email || !departure || !origin || !destination || !university) {
            alert("Please Fill all the details before submitting the form.");
            return;
        }
        e.preventDefault();
        // const form = document.getElementById('peer-mentorship-form');
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString(),
        })
            .then(() => {
                setStuName('');
                setEmail('');
                setDeparture('');
                setOrigin('');
                setDestination('');
                setUniversity('');
                setMajor('');
                navigate('/peer-mentorship-success');
            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Helmet>
                <title>Holistic Learning : Peer Mentorship Network</title>
                {/* <meta name="description" content="Welcome to Holistic Learning, your destination for content writing career opportunities in Bangalore." /> */}
                <link rel="canonical" href="https://holisitclearning.com/gulf-students/mentorship" />
            </Helmet>
            <section className="pre-departure-gulf-students-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-between">
                        <div className="col-md-6 pre-departure-gulf-students-heading-and-para-div">
                            <div className="pre-departure-gulf-students-heading-and-para-first-inner-div">
                                <h2>Gulf Student <span>Mentorship</span> Network</h2>
                                <p>Studying overseas is exciting — but it can also feel overwhelming. Our mentorship network connects Gulf students with alumni who’ve already walked the path. Whether you need help with housing, academics, culture shock, or career planning, your mentor is here to guide you. Join a community that understands your journey and wants you to succeed. Download the onboarding guide and meet your mentor today.</p>
                            </div>
                        </div>
                        <div className="col-md-6 pre-departure-gulf-students-image-div">
                            <img src={GulfStudents3} alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="leaving-your-abroad-soon-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 leaving-your-abroad-soon-heading-div">
                            <h2><span>Connect with Gulf Students</span> Already Studying in Your Target Country</h2>
                            <h4>Get insider advice, emotional support, and practical tips from those who’ve been there.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 planning-to-study-abroad-heading-div">
                            <h2>What You <span>Get</span></h2>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        {
                            PeerMentorNetworkData.map((item) => {
                                return (
                                    <div className="col-lg-3 col-md-6 col-sm-6 planning-to-study-abroad-card-div" key={item.id}>
                                        <div className="gulf-student-card-inner-div">
                                            <div className="what-we-offer-card-icon">
                                                <img src={item.bannerImg} alt="" />
                                            </div>
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
            <section className="why-it-matters-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 why-it-matters-heading-div">
                            <h2>Why It <span>Works</span></h2>
                            <h4>Real talk. Real support. Real results.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact-now-access-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 contact-now-access-heading-div">
                            <h2>Join the <span>Network</span></h2>
                        </div>
                        <div className="col-md-12 contact-now-form">
                            <form name="peer-mentorship-form" id="peer-mentorship-form" method="post" action="/peer-mentorship-success" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit={handleSubmit}>
                                <input type="hidden" name="form-name" value="peer-mentorship-form" />
                                <div className="row justify-content-center">
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" name='name' value={stuName} onChange={(e) => setStuName(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="departure" className="form-label">Departure Month</label>
                                        <input type="text" className="form-control" id="departure" name='departure' value={departure} onChange={(e) => setDeparture(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="origin" className="form-label">Origin Country</label>
                                        <input type="text" className="form-control" id="origin" name='origin' value={origin} onChange={(e) => setOrigin(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="destination" className="form-label">Destination Country</label>
                                        <input type="text" className="form-control" id="destination" name='destination' value={destination} onChange={(e) => setDestination(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="university" className="form-label">Intended University</label>
                                        <input type="text" className="form-control" id="university" name='university' value={university} onChange={(e) => setUniversity(e.target.value)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="major" className="form-label">Intended Major</label>
                                        <input type="text" className="form-control" id="major" name='major' value={major} onChange={(e) => setMajor(e.target.value)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-button-div">
                                        <button type="submit">Meet My Mentor</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="other-services-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 other-services-heading-div">
                            <h2>Other <span>Services</span></h2>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        {
                            GulfStudentsData.filter(item => item.id !== 3)
                                .map((item) => {
                                    return (
                                        <div className="col our-services-card-div" key={item.id}>
                                            <div className="our-services-card-inner-div">
                                                <div className="what-we-offer-card-icon">
                                                    <img src={item.bannerImg} alt="" />
                                                </div>
                                                <h5>{item.heading}</h5>
                                                <p>{item.text}</p>
                                                {item.link}
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </section>
            <TestimonialCard data={PeerMentorshipNetworkData} title={<><span>Social</span> Proof</>} />
        </>
    )
}

export default PeerMentorshipNetwork